import{ React, Component} from "react";
import Icons from "../../../icon";
import { NoSubscription } from "../../../../components/external/dashboard/no-subscription/no-subscription.component";
//import { PaginationExhibit1 as Pagination, PaginationExhibit3 as Pagination3, PaginationExhibit4 as Pagination4 } from "../pagination.component";
export class DataTable extends Component {

    constructor(props) {
        super(props);
        this.getDataOnTable=this.getDataOnTable.bind(this);
        this.state={
            itemSelected:false
        }
    }

    componentDidMount() {       
        this.checkStatus();
      }

      checkStatus() {
        const statusList = document.querySelectorAll(".internal-data-table table tbody td");       
       
        for (var i = 0; statusList.length > i; i++) {
              
                if (
                  statusList[i].innerText.toLowerCase().includes("Expired".toLowerCase())
                ) {                        
                    statusList[i].classList.add("data-expired");         
                } else  if (
                    statusList[i].innerText.toLowerCase().includes("Active".toLowerCase())
                  ) {                   
                      statusList[i].classList.add("data-active");                
                  }
              }     
      }

      getDataOnTable(e) {      
        this.setState({itemId: true})
        if(this.props.getData)
        {
            this.props.getData(true);
        }
          
        if(this.props.rowId) 
        {
            this.props.rowId(e.target.id) 
        } 
         
      }

      handelLink(id){
        this.props.handelLink(id)
      }

    render() {
        const { id, item, isDataLoaded, customClassName, pages, paginationAction, havePagination, showSearchBox, header, data } = this.props;
        return(
           <div className={customClassName}>
                 <table key={id} className="table-fit table">
                        {isDataLoaded ?  
                            (<><thead>                                   
                                    <tr>
                                        {Object.keys(header).map((headerList, index) => (
                                             <th key={index}>
                                                    <div className="header-content">{header[headerList].name}
                                                        <Icons
                                                            name="sort-down-solid"
                                                            size="14px"
                                                            customClassName="icon-table-header"
                                                            />
                                                    </div>   
                                                    {showSearchBox ?  <input type="text" placeholder="Enter..." className="data-table-search"/> : "" }                                               
                                              </th>                                            
                                        ))}
                                    </tr>
                            </thead>
                            <tbody>                           
                                    
                                    {data.map((item, indexId) => (
                                        <tr key={indexId} onClick={this.getDataOnTable}>
                                            {header.map((headerItem, index) => {
                                                return (
                                                    <td key={index} id={indexId}>
                                                         {headerItem.isLink 
                                                                ? <span className="list-item-link" onClick={()=>this.handelLink(item.RequestTypeID)}>{item[headerItem.name]}</span> 
                                                                : item[headerItem.name]
                                                          }
                                                    </td>
                                                );
                                            })}                                          
                                        </tr>
                                    ))}
                            </tbody></>) : <NoSubscription customClass="loading-page" title="Loading, Please Wait " />

                        }
                    </table>
                {/* {isDataLoaded && havePagination ? <Pagination pages={pages} action={paginationAction}/>  : ""} */}
           </div>
        )
    }
}

export class DataTable2 extends Component {

    constructor(props) {
        super(props);
        this.getDataOnTable=this.getDataOnTable.bind(this);
        this.state={
            itemSelected:false,
            columns: {},
            pageList: []
        }
    }

    componentDidMount() {
        this.setState({
            columns: { ...this.props.columns },
            pageList: this.props.pageList
        });       
        this.checkStatus();
      }

      checkStatus() {
        const statusList = document.querySelectorAll(".internal-data-table table tbody td");       
       
        for (var i = 0; statusList.length > i; i++) {
              
                if (
                  statusList[i].innerText.toLowerCase().includes("Expired".toLowerCase())
                ) {                        
                    statusList[i].classList.add("data-expired");         
                } else  if (
                    statusList[i].innerText.toLowerCase().includes("Active".toLowerCase())
                  ) {                   
                      statusList[i].classList.add("data-active");                
                  }
              }     
      }

      getDataOnTable(e) {      
        this.setState({itemId: true})
        if(this.props.getData)
        {
            this.props.getData(true);
        }
          
        if(this.props.rowId) 
        {
            this.props.rowId(e.target.id) 
        } 
         
      }

      handelLink(id){
        this.props.handelLink(id)
      }

    render() {
        const { id, item, isDataLoaded, customClassName, pages, paginationAction, havePagination, showSearchBox, header, data, circuitID, searchVal } = this.props;
        return(
           <div className={customClassName}>
                 <table key={id} className="table-fit table">
                        {isDataLoaded ?  
                            (<><thead>                                   
                                    <tr>
                                        {Object.values(header[0]).filter(x => x.hidden != true).map((headerList, index) => (
                                             <th key={index}>
                                                    <div className="header-content">{headerList.name}
                                                        <Icons
                                                            name="sort-down-solid"
                                                            size="14px"
                                                            customClassName="icon-table-header"
                                                            />
                                                    </div>   
                                                    {showSearchBox ?  <input type="text" placeholder="Enter..." className="data-table-search"/> : "" }                                               
                                              </th>                                            
                                        ))}
                                    </tr>
                            </thead>
                            <tbody>                           
                                    {
                                        data.map((item, indexId) => (
                                            <tr key={indexId} onClick={this.getDataOnTable}>
                                                {
                                                    Object.values(header[0]).filter(x => x.hidden != true).map((headerList, index) => {
                                                        var row = Object.values(item)
                                                        return (
                                                            (
                                                                <td key={index} id={indexId}>
                                                                     {headerList.isLink 
                                                                            ? <span className="list-item-link" onClick={()=>this.handelLink(row[index])}>{row[index]}</span> 
                                                                            : row[index]
                                                                      }
                                                                </td>
                                                            )
                                                        )
                                                    }
                                                    )
                                                }
                                            </tr>                             
                                        )
                                        )
                                    }
                                    
                            </tbody></>) : <NoSubscription customClass="loading-page" title="Loading, Please Wait " />

                        }
                    </table>
                {/* {isDataLoaded && havePagination ? <Pagination3 pages={pages} action={paginationAction} circuitId={circuitID} searchVal={searchVal}  pageLength={this.props.totalPage}/>  : ""} */}
           </div>
        )
    }
}

export class DataTable3 extends Component {

    constructor(props) {
        super(props);
        this.getDataOnTable=this.getDataOnTable.bind(this);
        this.state={
            itemSelected:false,
            columns: {},
            pageList: []
        }
    }

    componentDidMount() {
        this.setState({
            columns: { ...this.props.columns },
            pageList: this.props.pageList
        });       
        this.checkStatus();
      }

      checkStatus() {
        const statusList = document.querySelectorAll(".internal-data-table table tbody td");       
       
        for (var i = 0; statusList.length > i; i++) {
              
                if (
                  statusList[i].innerText.toLowerCase().includes("Expired".toLowerCase())
                ) {                        
                    statusList[i].classList.add("data-expired");         
                } else  if (
                    statusList[i].innerText.toLowerCase().includes("Active".toLowerCase())
                  ) {                   
                      statusList[i].classList.add("data-active");                
                  }
              }     
      }

      getDataOnTable(e) {      
        this.setState({itemId: true})
        if(this.props.getData)
        {
            this.props.getData(true);
        }
          
        if(this.props.rowId) 
        {
            this.props.rowId(e.target.id) 
        } 
         
      }

      handelLink(id){
        this.props.handelLink(id)
      }

    render() {
        const { id, item, isDataLoaded, customClassName, pages, paginationAction, havePagination, showSearchBox, header, data, searchVal, billingAccountID } = this.props;
        return(
           <div className={customClassName}>
                 <table key={id} className="table-fit table">
                        {isDataLoaded ?  
                            (<><thead>                                   
                                    <tr>
                                        {Object.values(header[0]).filter(x => x.hidden != true).map((headerList, index) => (
                                             <th key={index}>
                                                    <div className="header-content">{headerList.name}
                                                        <Icons
                                                            name="sort-down-solid"
                                                            size="14px"
                                                            customClassName="icon-table-header"
                                                            />
                                                    </div>   
                                                    {showSearchBox ?  <input type="text" placeholder="Enter..." className="data-table-search"/> : "" }                                               
                                              </th>                                            
                                        ))}
                                    </tr>
                            </thead>
                            <tbody>                           
                                    {
                                        data.map((item, indexId) => (
                                            <tr key={indexId} onClick={this.getDataOnTable}>
                                                {
                                                    Object.values(header[0]).filter(x => x.hidden != true).map((headerList, index) => {
                                                        var row = Object.values(item)
                                                        return (
                                                            (
                                                                <td key={index} id={indexId}>
                                                                     {headerList.isLink 
                                                                            ? <span className="list-item-link" onClick={()=>this.handelLink(row[index])}>{row[index]}</span> 
                                                                            : row[index]
                                                                      }
                                                                </td>
                                                            )
                                                        )
                                                    }
                                                    )
                                                }
                                            </tr>                             
                                        )
                                        )
                                    }
                                    
                            </tbody></>) : <NoSubscription customClass="loading-page" title="Loading, Please Wait " />

                        }
                    </table>
                {/* {isDataLoaded && havePagination ? <Pagination4 pages={pages} action={paginationAction} billingAccountID={billingAccountID} searchVal={searchVal}  pageLength={this.props.totalPage}/>  : ""} */}
           </div>
        )
    }
}